import type { MerchantUser } from 'api/merchantUsers'

// camelCase-at-the-boundary normalizer: merchantUsersApi returns snake_case, so
// build the rendered name here rather than leaking `first_name` into JSX. Falls
// back to the email when the user has no name yet (e.g. a pending invite).
//
// Shared across the RecoveryAI scene (the escalation picker and the activation
// preparer list both need it); importing one from the other would drag that
// subtree's components into the wrong bundle.
export const displayName = (user: MerchantUser): string =>
  [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email
